import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk } from '../../app/store';
import { RecordData } from '../../utilities/utility.type';
import { PrintDataStructure } from '../../models/sift/json/print-model';
import { shopOrder } from './asny-action/shop-order.print';
import { apiActions } from '../api-slice';
import { ApiPrintShopOrderDataGet, PrintShopOrderDataGetResponse } from '../../api/sift/front/api-print-meta-shop-order-data';
import { ResponseBase } from '../../api/response-base';
import { ApiPrintMetaShopOrderGet, MetaPrintShopOrderGetResponse } from '../../api/sift/front/api-print-meta-shop-order';
import { PrintTrimData } from '../../trim-editor/model/trim.print-model';

export type PrintShopOrderState = {
  meta: PrintDataStructure,
  image: PrintTrimData[],
}

type Data = {
  printShopOrderData: Partial<RecordData<{ meta: PrintDataStructure,image: PrintTrimData[] }>>,
  printShopOrderMeta: Partial<RecordData<MetaPrintShopOrderGetResponse>>,
  filePath: string,
  /* 注文作成画面から保存せず終了するときに確認するフラグ */
  isNextRouteSelectImage: boolean,
};

const initialState: Data = {
  printShopOrderData: {},
  printShopOrderMeta: {},
  filePath: '',
  isNextRouteSelectImage: false,
};

export const printSlice = createSlice({
  name: 'matomete-print',
  initialState,
  reducers: {
    setShopOrderData: (state, action: PayloadAction<PrintShopOrderState>) => {
      const {
        shopOrderId,
      } = action.payload.meta;
      state.printShopOrderData[shopOrderId] = action.payload;
    },
    setShopOrderMeta: (state, action: PayloadAction<MetaPrintShopOrderGetResponse>) => {
      state.printShopOrderMeta[action.payload.shopOrderId] = action.payload;
    },
    setPath: (state, action: PayloadAction<string>) => {
      state.filePath = action.payload;
    },
    setIsNextRouteSelectImage: (state, action: PayloadAction<boolean>) => {
      state.isNextRouteSelectImage = action.payload;
    },
  }
});
export type GetJsonListData =  {
  filename: string;
  body: string;
}[]
const asyncAction = {
  getShopOrderData: (
    kijshopCd: string,
    shopOrderId: string,
    callback?: { 
      onSuccess?: (data: PrintShopOrderState, originalRes: GetJsonListData) => void,
      onError?: () => void,
    },
  ): AppThunk => async (dispatch) => {
    dispatch(apiActions.run(
      new ApiPrintShopOrderDataGet({
        kijshopCd,
        shopOrderId,
      }),
      {
        onSuccess: (res: ResponseBase<PrintShopOrderDataGetResponse>) => {
          if (!res.body.data || (Number(res.error?.errorCode) !== 200)) {
            callback?.onError?.();
          } else {
            dispatch(printActions.setPath(res.body.data?.path ?? ''));
            const target = res.body.data.jsonList.find((v) => v.filename.includes(shopOrderId));
            if (!target) {
              callback?.onError?.();
              return;
            } else {
              try {
                const data = JSON.parse(target.body);
                const result = new PrintDataStructure(`${target.filename}`, data);
                const images = res.body?.data?.jsonList?.filter((v) => v !== target)
                  .map((v) => {
                    const obj = JSON.parse(v.body);
                    return new PrintTrimData(v.filename, obj);
                  });
                dispatch(printActions.setShopOrderData({ meta: result, image: images }));
                callback?.onSuccess?.({ meta: result, image: images }, res.body.data?.jsonList ?? [])
              } catch(e) {
                callback?.onError?.();
              }
            };
          }
        },
        onError: () => {
          callback?.onError?.();
        }
      }
    ));
  },
  getOrderMeta: (
    kijshopCd: string,
    shopOrderId: string,
    callback?: { 
      onSuccess?: (data: MetaPrintShopOrderGetResponse) => void,
      onError?: () => void,
    },
  ): AppThunk => async(dispatch) => {
    dispatch(apiActions.run(
      new ApiPrintMetaShopOrderGet({
        kijshopCd,
        shopOrderId,
      }),
      {
        onSuccess: (res: ResponseBase<MetaPrintShopOrderGetResponse>) => {
          if (!res.body.data || (Number(res.error?.errorCode) !== 200)) {
            callback?.onError?.();
          } else {
            const data = res.body.data;
            if (!data) {
              callback?.onError?.();
              return;
            } else {
              try {
                dispatch(printActions.setShopOrderMeta(data));
                callback?.onSuccess?.(data)
              } catch(e) {
                callback?.onError?.();
              }
            };
          }
        },
        onError: (e) => {
          console.log(e);
          callback?.onError?.();
        }
      }
    ))
  },
  shopOrder,
};

export const printActions = Object.assign(
  printSlice.actions,
  asyncAction,
);
// export const printActions = printSlice.actions;
export const printReducer = printSlice.reducer;
